import React from 'react';
import PropTypes from 'prop-types';

import OntraccrTag from './OntraccrTag';

export default function IntegrationTag({
  id,
  title,
}) {
  if (!id) return null;

  return (
    <OntraccrTag
      key={id}
      style={{
        maxWidth: 325,
        margin: 3,
        overflow: 'hidden',
      }}
    >
      {title}
    </OntraccrTag>
  );
}

IntegrationTag.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
};

IntegrationTag.defaultProps = {
  id: null,
};
